import { Button, Card, Input, Space } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { getCommandLogs } from '../../api/Services';
import DataTable from '../../components/table/DataTable';
// import moment from 'moment';
import { SearchOutlined } from '@ant-design/icons';
import moment from 'jalali-moment';
import { IoChevronBack } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import useCalendar from '../../hooks/useCalendar';

export const CommandLogs = () => {
  const calendar = useCalendar();
  const navigate = useNavigate();
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
  };
  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
  };
  const getColumnSearchProps = (dataIndex, filterCallback) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div
        style={{
          padding: 8,
        }}
      >
        <Input
          className="rounded-lg border border-gray-200 p-0.5"
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            size="small"
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters, confirm)}
            size="small"
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
    ),
    onFilter:
      filterCallback ||
      ((value, record) =>
        record[dataIndex]
          ?.toString()
          .toLowerCase()
          .includes(value.toLowerCase())),
  });

  const columns = [
    {
      title: 'User Name',
      dataIndex: 'User.username',
      align: 'center',
      fixed: 'left',
      width: 125,
      render: (_, record) => record.User?.username || '--',
      ...getColumnSearchProps('username', (value, record) =>
        record.User?.username
          ?.toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
      ),
    },
    {
      title: 'Creation Date',
      dataIndex: 'CreationDate',
      align: 'center',
      width: 125,
      render: (text) =>
        calendar
          ? moment(text).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss') // Persian date format
          : moment(text).format('YYYY-MM-DD HH:mm:ss'),
      ...getColumnSearchProps('CreationDate', (value, record) => {
        const formattedDate = calendar
          ? moment(record.CreationDate)
              .locale('fa')
              .format('jYYYY/jMM/jDD HH:mm:ss')
          : moment(record.CreationDate).format('YYYY-MM-DD HH:mm:ss');
        return formattedDate.includes(value);
      }),
      sorter: (a, b) => {
        // Convert the dates into timestamps for accurate comparison
        const dateA = moment(a.CreationDate).valueOf();
        const dateB = moment(b.CreationDate).valueOf();
        return dateA - dateB; // Ascending order
      },
      defaultSortOrder: 'descend', // Sort by descending date by default
    },
    {
      title: 'Device Name',
      dataIndex: 'DeviceName',
      align: 'center',
      width: 125,
      ...getColumnSearchProps('DeviceName'),
    },
    {
      title: 'Parameter Name',
      dataIndex: 'Request_body.parameter_name',
      align: 'center',
      width: 125,
      render: (_, record) => record.Request_body?.parameter_name || '--',
      ...getColumnSearchProps('parameter_name', (value, record) =>
        record.Request_body?.parameter_name
          ?.toLowerCase()
          .includes(value.toLowerCase()),
      ),
    },
    {
      title: 'Status',
      dataIndex: 'Request_body.status',
      align: 'center',
      width: 125,
      render: (_, record) => record.Request_body?.status || '--',
      ...getColumnSearchProps('status', (value, record) =>
        record.Request_body?.status
          ?.toLowerCase()
          .includes(value.toLowerCase()),
      ),
    },
  ];

  const [state, setState] = useState({
    data: [],
    loading: false,
  });

  useEffect(() => {
    getCommandLog();
  }, []);

  const getCommandLog = async () => {
    setState({ ...state, loading: true });
    try {
      const { data } = await getCommandLogs();
      setState({ data: data.result.logs, loading: false });
      //   console.log(data);
    } catch (error) {
      //   console.log(error);
      setState({ ...state, loading: false });
    }
  };

  return (
    <div className="flex flex-col gap-1">
      <Card className="rounded-t-3xl">
        <div className="flex flex-row items-center">
          <span className="pr-4 cursor-pointer" onClick={() => navigate(-1)}>
            <IoChevronBack size={30} />
          </span>
          <h className="font-bold text-xl">Command Logs</h>
        </div>
      </Card>
      <Card className="rounded-b-3xl h-[75vh]">
        <DataTable
          dataSource={state.data || []}
          header={columns}
          pagination={true}
          scroll={window.screen.height > 1400 ? 520 : 450}
          loading={state.loading}
        />
      </Card>
    </div>
  );
};
